import { IConversation, IMessage } from '../models/chatbot.interfaces';

export namespace ChatbotActions {
  export class LoadLatest {
    static readonly type = '[Chatbot] Load latest';
  }

  export class HasErrorLoadingConversation {
    static readonly type = '[Chatbot] Has Chatbot Error Loading Conversation';

    constructor(public latestError: string | null) {}
  }

  export class Initialise {
    static readonly type = '[Chatbot] Initialise Chatbot and Messages';

    constructor(public conversationObject: IConversation) {}
  }

  export class ConnectWS {
    static readonly type = '[Chatbot] Connect WebSocket Chatbot';

    constructor(public conversationObject: IConversation) {}
  }

  export class DisconnectWS {
    static readonly type = '[Chatbot] WS Disconnect';
  }

  export class StartNewWSConversation {
    static readonly type = '[Chatbot] Start New WebSocket Conversation';
  }

  export class NewWSConversationReady {
    static readonly type = '[Chatbot] New WebSocket Conversation Ready';

    constructor(public conversation: IConversation) {}
  }

  export class SendWSMessage {
    static readonly type = '[Chatbot] WS Send';

    constructor(
      public conversationId: string,
      public message: string,
      public entityContextRoute: string
    ) {}
  }

  export class WSStart {
    static readonly type = '[Chatbot] WS START';

    constructor(
      public conversationId: string,
      public serverMessageId: string
    ) {}
  }

  export class WSChunk {
    static readonly type = '[Chatbot] WS CHUNK';

    constructor(
      public conversationId: string,
      public data: string,
      public seq: number | null,
      public serverMessageId: string
    ) {}
  }

  export class WSComplete {
    static readonly type = '[Chatbot] WS COMPLETE';

    constructor(
      public conversationId: string,
      public serverMessageId: string
    ) {}
  }

  export class WSError {
    static readonly type = '[Chatbot] WS ERROR';

    constructor(
      public conversationId: string,
      public error: string
    ) {}
  }

  export class AppendUiMessage {
    static readonly type = '[Chatbot] Append UI Message';

    constructor(public message: IMessage) {}
  }

  export class ToggleMinimise {
    static readonly type = '[Chatbot] Toggle Minimise Chatbot';

    constructor(public isMinimised: boolean) {}
  }

  export class ToggleFullScreen {
    static readonly type = '[Chatbot] Toggle FullScreen Chatbot';

    constructor(public isFullScreen: boolean) {}
  }

  export class MobileTagView {
    static readonly type = '[Chatbot] Mobile Tag UI Chatbot';

    constructor(public isMobile: boolean) {}
  }

  export class WarningStateUI {
    static readonly type = '[Chatbot] Warning State UI Chatbot';

    constructor(public isWarningState: boolean) {}
  }

  export class NewChatUI {
    static readonly type = '[Chatbot] New Chat UI Chatbot';

    constructor(public isNewChatState: boolean) {}
  }

  export class ToggleChatbotThinking {
    static readonly type = '[Chatbot] Toggle Chatbot Thinking';

    constructor(public isThinking: boolean) {}
  }

  export class SetUnreadMessages {
    static readonly type = '[Chatbot] Set Unread Messages Indicator';

    constructor(public hasUnreadMessages: boolean) {}
  }

  export class SetChatbotIconWithSidePanel {
    static readonly type = '[Chatbot] Set Chatbot Icon With SidePane Open';

    constructor(public isSidePanelOpen: boolean) {}
  }

  export class Reset {
    static readonly type = '[Chatbot] Reset';
  }
}
